export default __webpack_public_path__ + "static/media/depot.78937cc0.svg";